import { Suspense, useRef } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import { Galaxy } from './Galaxy';
import { SpiralStars } from './SpiralStars';
import { StarField } from './StarField';
import * as THREE from 'three';

const RotatingGroup = () => {
  const groupRef = useRef<THREE.Group>(null);
  return (
    <group ref={groupRef}>
      <SpiralStars />
      <Galaxy />
    </group>
  );
};

interface GalaxyBackgroundProps {
  className?: string;
  enableControls?: boolean;
  autoRotate?: boolean;
  autoRotateSpeed?: number;
}

export function GalaxyBackground({
  className = "w-full h-screen bg-black",
  enableControls = true,
  autoRotate = true,
  autoRotateSpeed = 0.2
}: GalaxyBackgroundProps) {
  return (
    <Canvas
      camera={{
        position: [0, 8, 20],
        fov: 60,
        up: [0, 0, 1]
      }}
      className={className}
    >
      <Suspense fallback={null}>
        <ambientLight color="#ffffff" intensity={0.1} />
        <pointLight color="#ffffff" position={[10, 10, 10]} intensity={0.5} />
        <StarField />
        <RotatingGroup />
        {enableControls && (
          <OrbitControls
            enableZoom={true}
            enablePan={false}
            enableRotate={false}
            zoomSpeed={0.5}
            minDistance={8}
            maxDistance={40}
            autoRotate={autoRotate}
            autoRotateSpeed={autoRotateSpeed}
          />
        )}
      </Suspense>
    </Canvas>
  );
}
